import { Coord, Direction } from './grid.js'

export type ShipType = 'destroyer' | 'patrol_boat' | 'ghost_sub'

export type ShipTrait = 'sonar_invisible'

/** Ship definition: type, size, and traits */
export interface ShipDef {
  type: ShipType
  size: number
  traits: ShipTrait[]
}

/** A placed ship on the board */
export interface Ship {
  type: ShipType
  /** Top-left or leftmost cell of the ship */
  origin: Coord
  direction: Direction
  size: number
}

/** Ship definitions with their sizes and traits */
export const SHIP_DEFS: Record<ShipType, ShipDef> = {
  destroyer: { type: 'destroyer', size: 3, traits: [] },
  patrol_boat: { type: 'patrol_boat', size: 2, traits: [] },
  ghost_sub: { type: 'ghost_sub', size: 2, traits: ['sonar_invisible'] },
}

/** All ship types a player must place */
export const ALL_SHIP_TYPES: ShipType[] = ['destroyer', 'patrol_boat', 'ghost_sub']

/** Check if a ship type has a given trait */
export function hasTrait(shipType: ShipType, trait: ShipTrait): boolean {
  return SHIP_DEFS[shipType].traits.includes(trait)
}
